import styled from "styled-components";

export const Contant = styled.div`
	background-color: ${({ theme }) => theme.white};
	padding: 10px 20px 15px;
	border-radius: 8px;
	border: 1px solid ${({ theme }) => theme.grayLight};
`;

export const ButtonGroup = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 10px;
	margin-top: 1.5rem;
`;
